"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisuallyHidden = exports.visuallyUnhiddenMixin = exports.visuallyHiddenMixin = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = require("../Box");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Visually the hide element, but present in DOM so that it is accessible
 * for screen readers.
 * See:
 * https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/
 * https://webaim.org/techniques/css/invisiblecontent/
 * https://www.scottohara.me/blog/2017/04/14/inclusively-hidden.html
 */
var visuallyHiddenMixin = (0, _styledComponents.css)(["clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;"]);
/** Reset to `inherit` all properties that cause visually-hidden */

exports.visuallyHiddenMixin = visuallyHiddenMixin;
var visuallyUnhiddenMixin = (0, _styledComponents.css)(["clip:inherit;clip-path:inherit;height:inherit;overflow:inherit;position:inherit;white-space:inherit;width:inherit;"]);
exports.visuallyUnhiddenMixin = visuallyUnhiddenMixin;

/**
 * Visually the hide element, but present in DOM so that it is accessible
 * for screen readers.
 * See:
 * https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/
 * https://webaim.org/techniques/css/invisiblecontent/
 * https://www.scottohara.me/blog/2017/04/14/inclusively-hidden.html
 */
var VisuallyHidden = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "VisuallyHidden",
  componentId: "sc-14bjfob-0"
})(["", " ", ""], visuallyHiddenMixin, function (_ref) {
  var show = _ref.show;
  return show && visuallyUnhiddenMixin;
});
exports.VisuallyHidden = VisuallyHidden;
//# sourceMappingURL=VisuallyHidden.js.map